const languageSwitcher = document.querySelectorAll('.language-switcher--desktop');

if (languageSwitcher) {
	languageSwitcher.forEach(element => {
		element.addEventListener('click', () => {
			element.classList.toggle('active');
			element.parentNode.querySelector('.language-switcher__list').classList.toggle('active');
		});

		window.addEventListener('click', () => {
			element.classList.remove('active');
			element.parentNode.querySelector('.language-switcher__list').classList.remove('active');
		});

		element.addEventListener('click', event => {
			event.stopPropagation();
		});
	});
}
